import { SpinLoadingContext } from '@/utils/context/spinLoading/SpinLoadingContext';
import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Spin } from 'antd';
import { useContext } from 'react';

export const SpinLoading = () => {
  const { loading } = useContext(SpinLoadingContext);

  return loading ? (
    <div className="fixed top-[50%] z-20 items-start self-center bg-transparent">
      <Flex align="center" gap="middle" className="bg-transparent">
        <Spin
          className="bg-transparent"
          indicator={
            <LoadingOutlined style={{ fontSize: 100, color: '#6DC49D', backgroundColor: 'transparent' }} spin />
          }
        />
      </Flex>
    </div>
  ) : null;
};
